import api from '../../../App/socket';

export const addPriceSuggestion = (modelId, newRecord) => (
    api.send({
        api: 'module',
        module: 'PlatformManagement',
        classMethod: 'addModelPriceSuggestion',
        options: {
            where: { _id: modelId },
            create: {
                note: newRecord,
            },
        },
    }).then((response) => response).catch((error) => error)
);

export const getPriceSuggestion = (modelId) => (
    api.send({
        api: 'db',
        model: 'Bike_model',
        action: 'Read',
        options: {
            attributes: [
                'price_suggestions.note',
                'price_suggestions.created_by',
                'price_suggestions.created_at',
            ],
            include: {
                model: 'User',
                path: 'price_suggestions.created_by',
                attributes: ['person.first_name', 'person.last_name'],
            },
            where: { _id: modelId },
            limit: 1,
        },
    }).then((response) => response).catch((error) => error)
);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/bikeModel.requests.js